module.exports = __webpack_public_path__ + "2ddd8e72a27199b9184ab1bbc6b8d358.pdf";